import { render, staticRenderFns } from "./addCardTicket.vue?vue&type=template&id=2cded5ac&scoped=true&"
import script from "./addCardTicket.vue?vue&type=script&lang=js&"
export * from "./addCardTicket.vue?vue&type=script&lang=js&"
import style0 from "./addCardTicket.vue?vue&type=style&index=0&id=2cded5ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cded5ac",
  null
  
)

export default component.exports